import React from 'react';
import { Table } from '@brighterion/br-ui';
import clsx from 'clsx';
import { RoleService } from 'Services';
import styles from './GroupCell.css';

type Props = {
    data: EmptyRuleGroup;
    handleEditRow?: Function;
};

const GroupCell = ({ data, handleEditRow }: Props) => {
    const { isThresholdEditorOnly } = RoleService;
    return (
        <Table.GroupByHeader
            handleEditRow={
                !isThresholdEditorOnly && RoleService.hasCreateRuleAccess
                    ? () => handleEditRow && handleEditRow(data)
                    : undefined
            }
            containerClassName={clsx('td', styles.groupBy)}
            title={data.name}
            count='0'
            dataTestId={`group-by-${data.id}`}
        />
    );
};

export default React.memo(GroupCell);
